import { useUser } from '@context/user'
import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useNavigate } from 'react-router-dom'
type Props = {
  text: string
  navigateRoute: string
  buttons: { buttonText: string; onClick: () => void }[]
}
export default function LogoutModal() {
  const navigate = useNavigate()
  const closeModal = useAppStore.use.closeModal()
  const {
    userActions: { logOut },
  } = useUser()
  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <div className='white-background logout-modal-overlay fixed inset-0 z-[1000000] flex flex-col items-center overflow-y-auto overflow-x-hidden'>
          <Dialog.Content className='dialog text-md fixed left-1/2 top-1/2 z-[1000001] h-min w-72 -translate-x-1/2 -translate-y-1/2 border-[1px] border-colorAtemporal bg-C/Color1 px-3 pt-2 text-left'>
            <Dialog.Title className='sr-only'>{'Cerrar sesión'}</Dialog.Title>
            <Dialog.Description className='sr-only'>
              {'¿Esta seguro de querer cerrar sesion?'}
            </Dialog.Description>
            <div className='flex flex-col items-center justify-center gap-y-1.5'>
              <p className='mb-1 font-normal'>{'¿Esta seguro de querer cerrar sesion?'}</p>
              <div className='button container my-2.5 flex w-full justify-center'>
                <button
                  onClick={() => {
                    closeModal()
                    navigate('/planner')
                    logOut()
                  }}
                  className='ml-4 mr-4 flex cursor-pointer items-center rounded-xl  bg-colorAtemporal px-4  text-sm font-normal text-C/Color1'
                >
                  {'Ok'}
                </button>
                <button
                  onClick={() => {
                    closeModal()
                    navigate('/planner')
                  }}
                  className='flex cursor-pointer items-center rounded-xl  bg-C/Color7 px-4  py-0.5 text-sm font-normal text-C/Color3'
                >
                  {'Cancelar'}
                </button>
              </div>
            </div>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
